import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-ai-insight',
  templateUrl: './ai-insight.component.html',
  styleUrls: ['./ai-insight.component.scss']
})
export class AiInsightComponent implements OnInit {
    safeEndpoint: SafeResourceUrl;
    // endpoint = environment.production ? 'https://datx.set/dwh/aiinsight.html' : 'https://datx.test.set/dwh/aiinsight.html';
    endpoint = 'https://test-hr.setstage.or.th/api/datx/ai-insight';
    constructor(
        private activateRoute: ActivatedRoute,
        private sanitizer: DomSanitizer
    ) { }
    
    ngOnInit() {
        this.safeEndpoint = this.sanitizer.bypassSecurityTrustResourceUrl(this.endpoint);
        this.activateRoute.queryParams.subscribe((q) => {
            const token = q["code"];
            if (token) {

            }
        });
    }
}